module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/paper-fonts-cf80da7f112e39306eaa81ee42dba9a9.png";